import { createAsyncThunk } from "@src/store/createAsyncThunk";
import type { EmbeddedMod } from "@src/store/slices/experienceBuilder/types";
import { initDraft } from "@src/store/slices/experienceBuilder/common/thunks/initDraft";
import { trackModEditStarted } from "@src/store/slices/experienceBuilder/common/thunks/mixPanel";

export const editMod = createAsyncThunk<void, EmbeddedMod>(
  "experienceBuilder/editMod",
  (mod, { dispatch }) => {
    void dispatch(trackModEditStarted({ mod }));
    void dispatch(initDraft(mod));
  }
);
